import React, { useEffect, useState } from 'react';

import { Sheet, SheetContent, SheetHeader, SheetTitle } from '#/components/ui';
import { apiEndpoints, queryKeys, useGetQuery, usePostMutation } from '#/services';
import { CompanyDetailsSkeleton, CompanyOverview, CompanySheetTable } from '.';

const CompanyDetailsSheet = ({ isSheetOpen, setIsSheetOpen, selectedCompany }) => {
    const [companyId, setCompanyId] = useState(null);
    const [queryParams, setQueryParams] = useState({});
    const [data, setData] = useState([]);

    const {
        data: companyData,
        isLoading,
        // refetch,
    } = useGetQuery({
        key: queryKeys?.SINGLE_COMPANY,
        url: apiEndpoints.GET_SINGLE_COMPANY(selectedCompany?.id),
        enabled: Boolean(companyId),
        params: queryParams,
    });

    useEffect(() => {
        if (companyData?.id === companyId) {
            setData(companyData);
        }
    }, [companyData, companyId]);

    useEffect(() => {
        if (isSheetOpen && selectedCompany?.id) {
            setCompanyId(selectedCompany.id);
        }
    }, [isSheetOpen, selectedCompany]);

    const handleClose = val => {
        setIsSheetOpen(val);
        if (!val) {
            setCompanyId(null);
        }
    };
    const { mutate: addToContacts, isLoading: addToContactLoading } = usePostMutation({
        url: apiEndpoints.ADD_TO_CONTACT,
        queryKey: [queryKeys.USER, queryKeys.MY_CONTACTS, queryKeys?.SINGLE_COMPANY],
        successMessage: 'Added to contact successfully!',
    });

    const handleAddToContacts = (id, isInContactList) => () => {
        if (!isInContactList) addToContacts({ payload: { employee: id } });
    };
    const isDataLoading = (isLoading || !data?.id) && !queryParams?.ordering;

    return (
        <Sheet open={isSheetOpen} onOpenChange={handleClose}>
            <SheetContent className='w-full p-0  rounded-l-[20px] shadow-2xl overflow-y-auto bg-white'>
                <SheetHeader className='bg-[#F9FAFB] py-4 pl-[60px]'>
                    <SheetTitle className='font-cormorant text-xl text-gray800 font-semibold'>
                        Company Details
                    </SheetTitle>
                </SheetHeader>

                <div className='p-6 flex flex-col gap-6 '>
                    {isDataLoading ? (
                        <CompanyDetailsSkeleton />
                    ) : (
                        <>
                            <CompanyOverview data={data} />
                            <CompanySheetTable
                                data={data?.employee}
                                isLoading={isDataLoading}
                                handleAddToContacts={handleAddToContacts}
                                setQueryParams={setQueryParams}
                                addToContactLoading={addToContactLoading}
                            />
                        </>
                    )}
                </div>
            </SheetContent>
        </Sheet>
    );
};

export { CompanyDetailsSheet };
